<script lang="ts" setup>
import SearchFilters from '../SearchFilters/index.ce.vue';
import CollectionsSearchResults from './Collections/index.ce.vue';
import UpdatesSearchResults from './Updates/index.ce.vue';
import StandardsSearchResults from './Standards/index.ce.vue';
import SaiLoader from '@/components/common/SaiLoader/index.ce.vue';
import { useSearchStore } from '../store/index.ts'
import { useI18n } from '@/plugins/i18n'
import { STANDARDS_SEARCH_TAB, COLLECTIONS_SEARCH_TAB, UPDATES_SEARCH_TAB } from '@/components/Search/constants.ts';


const searchStore = useSearchStore()

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

const isResultLoadedForAnySearchType = () => {
    return searchStore.isResultLoaded(STANDARDS_SEARCH_TAB) || searchStore.isResultLoaded(COLLECTIONS_SEARCH_TAB) || searchStore.isResultLoaded(UPDATES_SEARCH_TAB);
}
</script>

<template>
    <div class="search-results-wrapper">
        <div :class="['search-filters-pane', { 'disable-filters': !isResultLoadedForAnySearchType() && searchStore[searchStore.activeTab + '.result.loading'] }]">
            <SearchFilters></SearchFilters>
        </div>
        <div class="search-result-pane">
            <div class="search-result-container">
                <SaiLoader v-if="searchStore[searchStore.activeTab + '.result.loading']" :loaderText="t('fetchingResults')"></SaiLoader>
                <StandardsSearchResults v-if="searchStore.activeTab == STANDARDS_SEARCH_TAB"></StandardsSearchResults>
                <CollectionsSearchResults v-if="searchStore.activeTab == COLLECTIONS_SEARCH_TAB"></CollectionsSearchResults>
                <UpdatesSearchResults v-if="searchStore.activeTab == UPDATES_SEARCH_TAB"></UpdatesSearchResults>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    @use './style.scss';
</style>